import Container from "components/shared/container/Container";
import DoublerHero from "./doublerHero/DoublerHero";
import Form from "./form/Form";

import { DoublerStyled } from "./Doubler.styled";

export default function Doubler() {
    return (
        <DoublerStyled>
            <DoublerHero />
            <Container>
                <Form />
            </Container>
        </DoublerStyled>
    );
}
